var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { get } from "lodash";
import media from "@irati/ui/src/global/media";
import { FormattedMessage, FormattedCurrency } from "@irati/utils/lang";
import withBasket from "@irati/checkout/utils/basket/withBasket";
import Expand from "../ui/Expand/Expand";
import { Subtotal, ProductList, SelectedEmail, VAT } from "./CommonElements";
var MobileHeader = styled.h4(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 20px;\n  word-wrap: break-word;\n  ", "\n"], ["\n  margin-top: 20px;\n  word-wrap: break-word;\n  ",
    "\n"])), media.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 33px;\n  "], ["\n    margin-top: 33px;\n  "]))));
var MobileOrderSummary = /** @class */ (function (_super) {
    __extends(MobileOrderSummary, _super);
    function MobileOrderSummary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.calculateTotals = function () {
            var _a = _this.props, walletBalanceToUse = _a.walletBalanceToUse, basket = _a.basket;
            var breakdown = basket.breakdown.total;
            var currency = breakdown.currency;
            var subtotal = breakdown.amount + breakdown.serviceCharge;
            var discount = breakdown.originalPrice - subtotal;
            var total = subtotal - (walletBalanceToUse || 0);
            var vat = breakdown.vat;
            return {
                vat: vat,
                total: total,
                discount: discount,
                subtotal: subtotal,
                currency: currency
            };
        };
        _this.Sticky = function () {
            var _a = _this.calculateTotals(), total = _a.total, currency = _a.currency;
            return (React.createElement("div", { style: { marginTop: "20px" } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 10 },
                        React.createElement(FormattedMessage, { id: "perks.components.orderSummary.mobileOrderSummary.total" })),
                    React.createElement(Col, { xs: 2 },
                        React.createElement("div", { className: "pull-right" },
                            React.createElement(FormattedCurrency, { value: total, currency: currency })))),
                React.createElement("hr", null)));
        };
        return _this;
    }
    MobileOrderSummary.prototype.render = function () {
        var _a = this.props, email = _a.email, deal = _a.deal, _b = _a.walletBalanceToUse, walletBalanceToUse = _b === void 0 ? 0 : _b, basket = _a.basket;
        var breakdown = basket.breakdown;
        var _c = this.calculateTotals(), vat = _c.vat, total = _c.total, discount = _c.discount, subtotal = _c.subtotal, currency = _c.currency;
        var showProductList = this.props.basket.items.length > 0;
        var products = get(deal, "productConfig.products", []);
        return (React.createElement("div", { className: "mobileOrderSummary" },
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement(MobileHeader, null, deal.header),
                    showProductList && (React.createElement(Expand, { above: true, stickyComponent: this.Sticky },
                        React.createElement("hr", null),
                        email && React.createElement(SelectedEmail, { email: email }),
                        products.length > 0 && React.createElement(ProductList, { data: products, breakdown: breakdown }),
                        (discount > 0 || walletBalanceToUse > 0) && (React.createElement(Subtotal, { subtotal: subtotal, walletBalanceToUse: walletBalanceToUse, currency: currency, discount: discount })),
                        (total > 0 || walletBalanceToUse > 0) && (React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(VAT, { net: total, currency: currency, vat: vat }))))))))));
    };
    MobileOrderSummary.defaultProps = {
        email: "",
        deal: {},
        walletBalanceToUse: 0
    };
    return MobileOrderSummary;
}(Component));
export default withBasket(MobileOrderSummary);
var templateObject_1, templateObject_2;
